import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { alpha, keyframes } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const rollForward = keyframes`
  0%, 12% { transform: translateX(0); opacity: 0; }
  24% { opacity: 1; }
  68% { transform: translateX(var(--rollover-travel)); opacity: 1; }
  82%, 100% { transform: translateX(var(--rollover-travel)); opacity: 0; }
`;

const receiveData = keyframes`
  0%, 48%, 100% { opacity: 0; transform: scale(0.92); }
  68%, 78% { opacity: 1; transform: scale(1); }
`;

const RolloverYearSummary = ({
  sourceYear,
  targetYear,
  sourcePeriod,
  animate = true,
}) => (
  <Paper
    variant='outlined'
    sx={{ p: 2, borderRadius: 2, bgcolor: "action.hover" }}
  >
    <Stack direction='row' alignItems='center' spacing={1.5}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant='caption' color='text.secondary'>
          Selected source
        </Typography>
        <Typography variant='subtitle2' fontWeight={600}>
          YA {sourceYear ?? "—"}
        </Typography>
        {sourcePeriod && (
          <Typography variant='caption' color='text.secondary'>
            {sourcePeriod}
          </Typography>
        )}
      </Box>
      <Box
        aria-hidden='true'
        sx={{
          position: "relative",
          width: { xs: 44, sm: 100 },
          height: 24,
          flexShrink: 0,
          color: "primary.main",
          "--rollover-travel": { xs: "24px", sm: "80px" },
          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            right: 12,
            top: "calc(50% - 1px)",
            height: 2,
            borderRadius: 1,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
          },
        }}
      >
        <ArrowForwardIcon
          sx={{
            position: "absolute",
            right: 0,
            top: 2,
            fontSize: 20,
            opacity: 0.4,
          }}
        />
        {animate && (
          <ArrowForwardIcon
            sx={{
              position: "absolute",
              left: 0,
              top: 2,
              fontSize: 20,
              animation: `${rollForward} 2.6s ease-in-out infinite`,
              "@media (prefers-reduced-motion: reduce)": { display: "none" },
            }}
          />
        )}
      </Box>
      <Box
        sx={{
          position: "relative",
          flexShrink: 0,
          "&::before": {
            content: '""',
            position: "absolute",
            inset: -6,
            borderRadius: 1.5,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            opacity: 0,
            pointerEvents: "none",
            animation: animate
              ? `${receiveData} 2.6s ease-in-out infinite`
              : "none",
            "@media (prefers-reduced-motion: reduce)": { animation: "none" },
          },
        }}
      >
        <Typography variant='caption' color='text.secondary'>
          Destination
        </Typography>
        <Typography variant='subtitle2' fontWeight={600}>
          YA {targetYear ?? "—"}
        </Typography>
      </Box>
    </Stack>
  </Paper>
);

export default RolloverYearSummary;
